<template>
  <div class="social-widget" :class="{'social-widget--large': isLarge}">
    <div
      @click="openNewTab(donateUrl)"
      class="social-widget__donate-button"
      :class="{'social-widget__donate-button--large': isLarge}"
    >donate</div>
    <div class="social-widget--bottom">
      <img
        @click="openNewTab(icons['instagram'].url)"
        :src="icons['instagram'].icon"
        class="social-widget__icon"
        :class="{'social-widget__icon--large': isLarge}"
      />

      <img
        @click="openNewTab(icons['facebook'].url)"
        :src="icons['facebook'].icon"
        class="social-widget__icon"
        :class="{'social-widget__icon--large': isLarge}"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialWidget",
  data() {
    return {
      donateUrl:
        "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=B94QUGSE9BP5N"
    };
  },
  props: {
    color: {
      type: String,
      default: "black"
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openNewTab(url) {
      window.open(url);
    }
  },
  computed: {
    icons() {
      return {
        facebook: {
          icon: require(`@/assets/images/social/facebook_${this.color}.png`),
          url: "https://www.facebook.com/covidcanada"
        },
        instagram: {
          icon: require(`@/assets/images/social/instagram_${this.color}.png`),
          url: "https://www.instagram.com/covidracism.ca"
        }
      };
    }
  }
};
</script>
<style>
.social-widget {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 55px;
  height: 55px;
}
.social-widget--large {
  width: 70px;
  height: 120px;
}

.social-widget__donate-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 20px;
  background-color: rgb(54, 114, 184);
  border-radius: 30px;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  color: white;
  cursor: pointer;
}

.social-widget__donate-button--large {
  height: 40px;
  width: 100px;
  font-size: 16px;
}

.social-widget__icon {
  height: 20px;
  width: 20px;
  cursor: pointer;
}

.social-widget__icon--large {
  height: 30px;
  width: 30px;
}

.social-widget--bottom {
  display: flex;
  justify-content: space-evenly;
}
</style>